module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMyIgaGVpZ2h0PSIzNiIgdmlld0JveD0iMCAwIDIzIDM2Ij4KICAgIDx0ZXh0IGZpbGw9IiNBMUEzOUUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZm9udC1mYW1pbHk9Ik51bml0by1Cb2xkLCBOdW5pdG8iIGZvbnQtc2l6ZT0iNDgiIGZvbnQtd2VpZ2h0PSJib2xkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTc0IC01MzMpIj4KICAgICAgICA8dHNwYW4geD0iMTc1IiB5PSI1NzMiPj88L3RzcGFuPgogICAgPC90ZXh0Pgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/question.svg
// module id = PfSF
// module chunks = 1